import React from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../components/Table';
import { useDeleteQuizMutation, useGetAllQuizsQuery } from '../features/quiz/quizApi';

const AdminQuizs = () => {
  const tableHead=['Question','Video','Action']

  const {data:videos,isError,isLoading,isSuccess,error}= useGetAllQuizsQuery();
  const[deleteVideo, {}]=useDeleteQuizMutation();

 const tableKeyNames=['question','video_title'];
 const navigate=useNavigate();

 const handleEdit=(id)=>{
navigate(`/admin/quizs/edit/${id}`)
 }

 const handleDelete=(id)=>{
  deleteVideo(id)
 }

  return (
    <>
   <section className="py-6 bg-primary">
  <div className="mx-auto max-w-full px-5 lg:px-20">
    <div className="px-3 py-20 bg-opacity-10">
      <div className="w-full flex">
        <button className="btn ml-auto" onClick={()=>navigate('/admin/quizs/add')}>Add Quiz</button>
      </div>
     

<Table handleEdit={handleEdit} handleDelete={handleDelete} tableHead={tableHead} data={videos} tableKeyNames={tableKeyNames} showDelete={true}  showEdit={true} isSuccess={isSuccess} isError={isError} isLoading={isLoading}/>

    </div>
  </div>
</section>

    </>
  )
}

export default AdminQuizs